export const githubRepoPath = "gl-transitions/gl-transitions";
export const githubRepoFolder = "/transitions";
